import store from 'app/common/store';

const addToast = (status, message, options) => {
  store.commit('dialog/add', {
    type: 'toast',
    status,
    message,
    ...options,
  });
};

export default {
  store,
  install (Vue) {
    Vue.prototype.$toast = {
      success (message, options) {
        addToast('success', message, options);
      },
      fail (message, options) {
        addToast('fail', message, options);
      },
    };
  },
};



// WEBPACK FOOTER //
// ./common/plugins/toast.js